import { render, staticRenderFns } from "./CreateEditDistrict.vue?vue&type=template&id=fc13d6b6"
import script from "./CreateEditDistrict.vue?vue&type=script&lang=js"
export * from "./CreateEditDistrict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports